var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('safe-img',{style:(_vm.isHeaderAuto ? _vm.headerBgAuto : _vm.headerBg),attrs:{"src":_vm.bannerUrl,"placeholder":_vm.placeholder}})}
var staticRenderFns = []

export { render, staticRenderFns }